<template>
    <form id="fm_credit_card" class="form-horizontal pl-1">
        <b-form-group label-for="amount" label="Amount:" label-cols="3">
            <b-form-input
                v-if="isFixedAmount"
                id="amount"
                :value="
                    data.currency_symbol +
                    Number(data.payment_amount).toFixed(2)
                "
                plaintext
            ></b-form-input>
            <b-form-input
                v-else
                id="amount-field"
                v-model="data.payment_amount"
                v-validate="{ required: true, max_value: 999999 }"
                :class="{
                    'border-danger': errors.has('amount')
                }"
                name="amount"
                placeholder="Amount (required)"
                :disabled="(isPayNow && is_gravity && data.payNowGravityStep === 2)
                "
            ></b-form-input>
        </b-form-group>
        <b-form-group
            v-show="(data.show_payment_form === 1 && !is_gravity && (data.defaultPaymentMethod ? data.defaultPaymentMethod !== 'pay-over-time' : true))"
            :label-for="`name_on_card`"
            label="Name on Card:"
            label-cols="3"
        >
            <b-form-input
                id="credit_card_name_on_card"
                v-model="data.credit_card_name_on_card"
                v-validate="'required'"
                :class="{
                    'border-danger': errors.has('credit_card_name_on_card')
                }"
                name="credit_card_name_on_card"
                :placeholder="!isPayNow ? 'Name on Card (required)' : ''"
            ></b-form-input>
        </b-form-group>

        <!-- GRAVITY: PAY NOW ACCOUTN STATEMENT -->
        <b-form-group
            v-if="data.show_payment_form === 1 && is_gravity && isPayNow"
            :label-for="`name_on_card`"
            label="Name on Card:"
            label-cols="3"
        >
            <b-form-input
                id="credit_card_name_on_card"
                v-model="data.credit_card_name_on_card"
                v-validate="'required'"
                :class="{
                    'border-danger': errors.has('credit_card_name_on_card')
                }"
                name="credit_card_name_on_card"
                placeholder="Name on Card (required)"
                :disabled="data.payNowGravityStep === 2"
            ></b-form-input>
        </b-form-group>

        <!-- CARD CONNECT -->
        <b-form-group v-if="data.show_payment_form === 1 && is_cardconnect">
            <div v-show="data.cc_iframe_load" class="iframe_label">
                <label id="card_number">Card Number:</label>
                <label id="expiration">Expiration:</label>
                <label id="scode">Security Code</label>
                <a id="tip-info" href="#" @click.prevent>
                    <i
                        v-b-popover.hover.bottom="
                            'For Visa, MasterCard, and Discover, the security code is the last 3 digit number located on the back of the card or above the signature line. For American Express, it is the 4 digits on the front of the card above the end of the card number.'
                        "
                        class="cus-information"
                        container="app"
                        title="Note"
                    ></i> </a
                >:
            </div>
            <div v-show="data.cc_iframe_load" class="iframe_contentp">
                <iframe
                    id="tokenframe"
                    name="tokenframe"
                    :src="data.cardconnect_iframe_url"
                    frameborder="0"
                    scrolling="no"
                    @load="$emit('iframe-loaded')"
                >
                </iframe>
            </div>
        </b-form-group>
        <b-form-group
            v-if="
                data.show_payment_form === 1 &&
                is_cardconnect &&
                showSaveCardOption
            "
            label=""
            label-cols="3"
            style="margin-top: -0.525rem;"
            class="pl-2"
        >
            <b-form-checkbox
                id="save_card"
                v-model="data.save_card"
                value="1"
                plain
                unchecked-value="0"
                >Save card as payment method</b-form-checkbox
            >
        </b-form-group>
        <!-- END OF CARD CONNECT -->

        <!--  STRIPE -->
        <stripe-elements
            v-if="
                data.show_payment_form === 1 &&
                is_stripe &&
                data.defaultPaymentMethod == 'card'
            "
            ref="stripeElements"
            :data="data"
            :metadata="data"
            @isElementsLoaded="elementStatus"
            @isDisableSave="fieldStatus"
            @isIntentLoading="intentLoadingStatus"
        />

        <buy-now-pay-later
            v-else-if="(data.show_payment_form === 1 &&
            is_stripe &&
            (data.defaultPaymentMethod == 'pay-over-time'))"
            ref="bnplElements"
            @isElementsLoaded="elementStatus"
            @isDisableSave="fieldStatus"
            @isIntentLoading="intentLoadingStatus"
            :data="data"
            :metadata="data"
        />
        <!-- END OF STRIPE -->

        <!-- GRAVITY -->
        <b-form-group
            v-if="data.show_payment_form === 1 && is_gravity"
            style="margin-bottom: -0.525rem;"
        >
            <div v-show="data.giframe_load" class="giframe_label">
                <label id="gcard_number">Card Number:</label>
                <label id="gexpiration">Expiration:</label>
                <label id="gscode">Security Code:</label>
            </div>
            <div v-show="data.giframe_load" class="giframe_contentp">
                <div id="cardNumberContainer" style="height: 35px;"></div>
                <div id="expirationDateContainer" style="height: 35px;"></div>
                <div
                    id="securityCodeContainer"
                    style="height: 35px; float: left;"
                ></div>
                <div v-show="data.giframe_load" style="margin-top: 5px;">
                    <a id="gtip" href="#" class="ml-1" @click.prevent>
                        <i
                            v-b-popover.hover.bottom="
                                'For Visa, MasterCard, and Discover, the security code is the last 3 digit number located on the back of the card or above the signature line. For American Express, it is the 4 digits on the front of the card above the end of the card number.'
                            "
                            class="cus-information"
                            container="app"
                            title="Note"
                        ></i>
                    </a>
                </div>
            </div>
        </b-form-group>
        <b-form-group
            v-if="
                data.show_payment_form === 1 && is_gravity && showSaveCardOption
            "
            label=""
            label-cols="3"
            class="pl-2"
            style="margin-top: -0.525rem;"
        >
            <b-form-checkbox
                id="save_card"
                v-model="data.save_card"
                value="1"
                plain
                unchecked-value="0"
                >Save card as payment method</b-form-checkbox
            >
        </b-form-group>
        <!-- END OF GRAVITY -->

        <div v-if="!isPayNow">
            <br />
        </div>

        <div id="signature-section" v-if="showSignaturePad">
            <div class="row-fluid">
                <ul
                    class="sigNav nav nav-tabs subnavbar"
                    style="margin-bottom: 10px;"
                >
                    <li class="drawIt">
                        <a href="#draw-it">
                            <i class="cus-pencil"></i>Draw It
                        </a>
                    </li>
                    <li class="typeIt">
                        <a href="#type-it">
                            <i class="cus-keyboard"></i>Type It
                        </a>
                    </li>
                </ul>
                <div class="draw-panel">
                    <input
                        id="fm_credit_card_output"
                        type="hidden"
                        name="fm_credit_card_output"
                        class="output"
                    />
                </div>
                <div class="type-panel">
                    <b-form-group
                        :label-for="`card_number`"
                        label="Name:"
                        label-cols="3"
                    >
                        <b-form-input
                            id="fm_credit_card_name"
                            name="fm_credit_card_name"
                            class="form-control name col-12"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="typed"></div>
                <canvas class="pad" width="450" height="150"></canvas>
            </div>
        </div>
    </form>
</template>
<script>
import { map } from "lodash";
import "@/jquery/signature/jquery.signaturepad.js";
import "@/css/signature/jquery.signaturepad.css";
import PaymentDialogHelper from "@/module/payment/helper.js";
import StripeElements from "@/components/payments/stripe/stripe-elements";
import BuyNowPayLater from "@/components/payments/stripe/buy-now-pay-later";

export default {
    name: "Payment",
    components: { StripeElements, BuyNowPayLater },
    mixins: [PaymentDialogHelper],
    // props: ["data", "appData"],
    props: {
        data: Object,
        appData: Object,
        isPayNow: {
            type: Boolean,
            default: false
        },
        isFixedAmount: {
            type: Boolean,
            default: true
        },
        showSaveCardOption: {
            type: Boolean,
            default: true
        },
        showSignaturePad: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            gravity_iframe: false
        };
    },
    computed: {
        is_cardconnect() {
            return _.get(this, "data.credit_card_processor", "") === "CCONNECT";
        },

        is_gravity() {
            return _.get(this, "data.credit_card_processor", "") === "GRAVITY";
        },

        is_stripe() {
            return _.get(this, "data.credit_card_processor", "") === "STRIPE";
        }
    },
    watch: {
        "data.cardconnect_iframe_url": {
            handler(value) {
                if (value && value.includes("cardconnect.com")) {
                    this.$once("iframe-loaded", () => {
                        // TODO: kenapa tak masuk sini, tanya syahira
                        setTimeout(() => {
                            this.$emit("loaded");
                            this.data.cc_iframe_load = true;
                            let self = this;

                            window.addEventListener(
                                "message",
                                function (event) {
                                    // NOTE: avoid override amount field validation on online invoice modal
                                    if (self.data.myerror !== "ERROR: Please enter a valid amount" ) {
                                        self.data.myerror = "";
                                    }

                                    let token = JSON.parse(event.data);

                                    if (
                                        typeof token.message !== "undefined" &&
                                        typeof token.expiry !== "undefined"
                                    ) {
                                        self.data.mytoken = token.message;
                                        self.data.myexpiry = token.expiry;
                                    } else {
                                        if (
                                            typeof token.validationError !==
                                            "undefined"
                                        ) {
                                            self.data.myerror =
                                                token.validationError;
                                        }
                                    }
                                },
                                false
                            );
                        }, 350);
                    });
                } else {
                    this.data.cc_iframe_load = false;
                }
            },
            immediate: true
        },
        "data.payment_amount"(value) {
            if (this.isPayNow) {
                let properValue = Number(value);

                if (!isNaN(properValue)) {
                    if (properValue > this.data.payment_amount_max) {
                        this.data.overpaidMsg =
                            "The entered amount exceeds the invoiced amount. Any excess payment will be converted into credit.";
                    } else {
                        this.data.overpaidMsg = "";
                    }
                }
            }
        }
    },
    mounted() {
        if (this.showSignaturePad) {
            $("#fm_credit_card").signaturePad({
                defaultAction: "drawIt",
                drawOnly: false,
                clear: $(".clearButton"),
                lineWidth: 0,
                lineTop: 150,
                validateFields: true,
                penColour: "#00F",
                penWidth: 4
            });

            $(".typeIt").click(function () {
                $("div.type-panel").show();
                $("div.draw-panel").hide();
                $("[name=fm_credit_card_name]").prop(
                    "class",
                    "form-control name col-12"
                );
                $("[name=fm_credit_card_output]").prop("class", "output");
                $("[name=fm_credit_card_name]").prop("disabled", false);
                $("[name=fm_credit_card_name]").focus();
            });

            $(".drawIt").click(function () {
                $("div.draw-panel").show();
                $("div.type-panel").hide();
                $("[name=fm_credit_card_name]").prop("class", "name");
                $("[name=fm_credit_card_output]").prop(
                    "class",
                    "output required"
                );
                $("[name=fm_credit_card_name]").prop(
                    "style",
                    "background-color: none;"
                );
                $("[name=fm_credit_card_name]").prop("disabled", true);
                $("[name=fm_credit_card_name]").val("");
            });

            $(".drawIt").trigger("click");
        }

        if (
            this.is_gravity &&
            this.data.show_payment_form === 1 &&
            !this.isPayNow
        ) {
            var width = "100%";
            var mq = window.matchMedia("(max-width: 400px)");

            if (mq.matches) {
                width = "50%";
            }

            this.callGravityIFrame(width);
        }
    },
    methods: {
        open(event) {
            this.data = event;
            this.$refs.createPaymentModal.show();
        },
        async pay_checkout(checkout_data) {
            const sleep = m => new Promise(r => setTimeout(r, m));

            let self = this;
            let post = null;
            let valid = await self.$validator.validateAll();
            valid = await self.cconnectValidate();

            if (valid) {
                if (checkout_data.show_payment_form == 1) {
                    post = {
                        fm_credit_card_client_id: _.get(
                            self.appData,
                            "client.id"
                        ),
                        fm_credit_card_payment_amount:
                            checkout_data.payment_amount,
                        fm_credit_card_payment_type:
                            checkout_data.payment_type_object.name,
                        fm_credit_card_payment_type_id:
                            checkout_data.payment_type,
                        fm_credit_card_track1: "",
                        fm_credit_card_payment_method_id: "",
                        fm_credit_card_processor:
                            checkout_data.credit_card_processor,
                        fm_credit_card_name_on_card:
                            checkout_data.credit_card_name_on_card,
                        fm_credit_card_card_number:
                            checkout_data.credit_card_card_number,
                        fm_credit_card_expiry_month:
                            checkout_data.credit_card_expiry_month,
                        fm_credit_card_expiry_year:
                            checkout_data.credit_card_expiry_year,
                        fm_credit_card_ccv: checkout_data.credit_card_ccv,
                        fm_credit_card_output: $(
                            "#fm_credit_card_output"
                        ).val(),
                        fm_credit_card_name: $("#fm_credit_card_name").val(),
                        save_card: checkout_data.save_card
                    };

                    if (this.is_stripe) {
                        await self.$refs.stripeElements
                            .confirmPaymentStripe()
                            .then(response => {
                                if (response.code == 200) {
                                    post.stripe = {
                                        uniqueTransId: response.id,
                                        externalTransactionId:
                                            response.payment_method
                                    };
                                }
                            });

                        if (!post.stripe) {
                            return;
                        }
                    }

                    if (this.is_cardconnect) {
                        await sleep(4000);

                        post.fm_credit_card_mytoken = this.data.mytoken;
                        post.fm_credit_card_myexpiry = this.data.myexpiry;
                    }

                    if (this.is_gravity) {
                        post.gravity = {
                            uniqueTransId: checkout_data.uniqueTransId,
                            accountCardType: checkout_data.accountCardType,
                            accountExpiryDate: checkout_data.accountExpiryDate,
                            last4digit: checkout_data.last4digit,
                            externalTransactionId:
                                checkout_data.externalTransactionId
                        };
                    }
                } else {
                    post = {
                        fm_credit_card_client_id: _.get(
                            self.appData,
                            "client.id"
                        ),
                        fm_credit_card_payment_amount:
                            checkout_data.payment_amount,
                        fm_credit_card_payment_type:
                            checkout_data.payment_type_object.name,
                        fm_credit_card_payment_type_id:
                            checkout_data.payment_type,
                        fm_credit_card_track1: "",
                        fm_credit_card_payment_method_id:
                            checkout_data.payment_method_name.id ||
                            checkout_data.payment_method_name.payment_method_id,
                        fm_credit_card_processor:
                            checkout_data.credit_card_processor,
                        fm_credit_card_name_on_card: "",
                        fm_credit_card_card_number: "",
                        fm_credit_card_expiry_month: "",
                        fm_credit_card_expiry_year: "",
                        fm_credit_card_ccv: "",
                        fm_credit_card_output: $(
                            "#fm_credit_card_output"
                        ).val(),
                        fm_credit_card_name: $("#fm_credit_card_name").val(),
                        save_card: checkout_data.save_card
                    };

                    if (this.is_gravity) {
                        post.invoices = checkout_data.invoice_ids;
                    }
                }

                let response = await $.post(
                    process.env.APPS +
                        "index.php/billing/payment/saveCreditCard",
                    post,
                    "json"
                );
                if (response) {
                    if (response.state == 0) {
                        if (response.anet_transaction_id) {
                            checkout_data.anet_transaction_id =
                                response.anet_transaction_id;
                        }
                        if (response.anet_transaction_output) {
                            checkout_data.anet_transaction_output =
                                response.anet_transaction_output;
                        }
                        if (response.anet_transaction_name) {
                            checkout_data.anet_transaction_name =
                                response.anet_transaction_name;
                        }
                        if (response.payment_id) {
                            checkout_data.payment_id = response.payment_id;
                        }
                        if (response.external_id) {
                            checkout_data.external_id = response.external_id;
                        }
                        return checkout_data;
                    } else {
                        self._message(response.message, "warning");
                        return response;
                    }
                }
            } else {
                return false;
            }
        },
        async pay_quickadd() {
            let self = this;
            let stripeResponse = null;
            if (self.data.show_payment_form === 1 && self.is_stripe) {
                return await self.$refs.stripeElements
                    .confirmPaymentStripe()
                    .then(response => {
                        if (response.code == 200) {
                            stripeResponse = {
                                uniqueTransId: response.id,
                                externalTransactionId: response.payment_method
                            };
                        }
                        return stripeResponse;
                    });
            } else {
                return this.$validator.validateAll().then(result => {
                    if (result) {
                        let card_data = {
                            card_number: this.data.credit_card_card_number,
                            name_on_card: this.data.name_on_card,
                            expiry_month: this.data.credit_card_expiry_month,
                            expiry_year: this.data.credit_card_expiry_year,
                            save_card: this.data.save_card,
                            ccv: this.data.credit_card_ccv,
                            output: $("#fm_credit_card_output").val()
                        };
                        return card_data;
                    }
                });
            }
        },
        cconnectValidate() {
            let self = this;

            if (self.data.mytoken !== "" && self.data.myexpiry !== "") {
                return true;
            } else {
                let err = this.data.myerror;

                if (err !== "") {
                    if (err === "Invalid Account Number") {
                        self._message("Invalid card number", "danger");
                    }

                    if (err === "Invalid CVV") {
                        self._message("Invalid security code", "danger");
                    }

                    if (err === "Invalid Expiry") {
                        self._message("Invalid expiration date", "danger");
                    }

                    return false;
                }
            }
        },
        getToken() {
            let self = this;
            var amount = parseFloat(self.data.payment_amount).toString();
            var client_id = self.data.client_id;
            var trans_type = "1"; // -- gravity sale

            let invoices_list_param = self.data.invoices
                ? map(self.data.invoices, element => element.id).join(",")
                : "";

            return new Promise(function (resolve, reject) {
                let generateTokenRoute = "payment/generate-token";
                let businessId = "";

                if (self.isPayNow) {
                    generateTokenRoute = "payment/generate-token-online";
                    businessId = self.data.business_id;
                }

                self.$http
                    .post(process.env.BARRAMUNDI + generateTokenRoute, {
                        amount: amount,
                        client_id: client_id,
                        trans_type: trans_type,
                        invoices: invoices_list_param,
                        business_id: businessId,
                        client_name: self.data.credit_card_name_on_card
                    })
                    .then(function (response) {
                        if (response.data.response.token) {
                            resolve(response.data.response.token);
                        } else {
                            self._message(
                                "Error initializing payment",
                                "danger"
                            );
                        }
                    });
            });
        },
        callGravityIFrame(width) {
            let self = this;
            self.$emit("loading");

            self.getToken().then(function (transactionToken) {
                var hosted = emergepayFormFields.init({
                    // "emergepayFormFields" <-- came from gravity payment sdk (external js)
                    transactionToken: transactionToken,
                    transactionType: "CreditSale",
                    fieldSetUp: {
                        cardNumber: {
                            appendToSelector: "cardNumberContainer",
                            useField: true,
                            styles: {
                                padding: "6px",
                                border: "1px solid #cccccc",
                                "font-family":
                                    "Verdana, Helvetica, Arial, sans-serif",
                                "font-size": "12px",
                                width: width
                            }
                        },
                        cardExpirationDate: {
                            appendToSelector: "expirationDateContainer",
                            useField: true,
                            styles: {
                                padding: "6px",
                                border: "1px solid #cccccc",
                                "font-family":
                                    "Verdana, Helvetica, Arial, sans-serif",
                                "font-size": "12px",
                                width: width
                            }
                        },
                        cardSecurityCode: {
                            appendToSelector: "securityCodeContainer",
                            useField: true,
                            styles: {
                                padding: "6px",
                                border: "1px solid #cccccc",
                                "font-family":
                                    "Verdana, Helvetica, Arial, sans-serif",
                                "font-size": "12px",
                                width: width
                            }
                        },
                        totalAmount: {
                            appendToSelector: "amountContainer",
                            useField: false,
                            styles: {}
                        },
                        externalTranId: {
                            useField: false,
                            styles: {}
                        }
                    },
                    fieldErrorStyles: {
                        "border-color": "#b94a48",
                        "background-color": "#ffdddd"
                    },
                    onFieldError: function (data) {
                        self.$emit("loaded", true);

                        setTimeout(() => {
                            $("#save-btn").on("click", function (event) {
                                self.$emit("loading");
                                event.preventDefault();
                                hosted.process();
                            });
                        }, 2000);
                    },
                    onTransactionSuccess: function (approvalData) {
                        if (
                            approvalData.resultMessage == "Approved" &&
                            approvalData.resultStatus == "true"
                        ) {
                            self.data.uniqueTransId =
                                approvalData.uniqueTransId;
                            self.data.accountCardType =
                                approvalData.accountCardType;
                            self.data.accountExpiryDate =
                                approvalData.accountExpiryDate;
                            self.data.last4digit = approvalData.maskedAccount;
                            self.data.externalTransactionId =
                                approvalData.externalTransactionId;
                            self.data.gravity_button = width;

                            if (self.isPayNow) {
                                self.$emit("save-gravity", self.data);
                            } else {
                                self.$emit("save", self.data);
                            }
                        } else {
                            self.callGravityIFrame(width);

                            let msg =
                                "Transaction failed. " +
                                approvalData.resultMessage +
                                ". Please try again.";

                            if (self.isPayNow) {
                                self.data.myerror = msg;
                            } else {
                                self._message(msg, "danger");
                            }
                        }
                    },
                    onTransactionFailure: function (failureData) {
                        self.callGravityIFrame(width);

                        let msg =
                            "Transaction failed. " +
                            failureData.resultMessage +
                            ". Please try again.";

                        if (self.isPayNow) {
                            self.data.myerror = msg;
                        } else {
                            self._message(msg, "danger");
                        }
                    }
                });

                self.$emit("loaded");

                setTimeout(() => {
                    self.data.gravity_payment_token = transactionToken;
                    self.data.giframe_load = true;

                    $("#save-btn").on("click", function (event) {
                        self.$emit("loading");
                        event.preventDefault();
                        hosted.process();
                    });
                }, 2000);
            });
        },
        elementStatus(loaded) {
            if (loaded) {
                this.$emit("loaded");
            } else {
                this.$emit("loading");
            }
        },
        fieldStatus(isDisabled) {
            if (isDisabled) {
                this.$emit("disableSaveButton", true);
            } else {
                this.$emit("disableSaveButton", false);
            }
        },
        intentLoadingStatus(isLoading) {
            if (isLoading) {
                this.$emit("intentLoading", true);
            } else {
                this.$emit("intentLoading", false);
            }
        }
    }
};
</script>
<style lang="scss">
#amount,
#amount-field,
#credit_card_name_on_card,
#cardNumberContainer,
#expirationDateContainer,
#securityCodeContainer {
    margin-left: 2px;
}

#amount-field,
#credit_card_name_on_card {
    max-width: 327px;
}

iframe#ccNumIframe,
iframe#expDateIframe {
    width: 100%;
}

iframe#tokenframe {
    width: 102%;
    height: 120px;
    margin-top: -8px;
    margin-left: -0.25rem;
}

.iframe_label,
.giframe_label {
    width: 26%;
    height: 120px;
    float: left;
    label#card_number,
    label#gcard_number {
        margin-top: 5px;
    }
    label#expiration,
    label#gexpiration {
        margin-top: 8px;
    }
    label#scode,
    label#gscode {
        margin-top: 10px;
    }
}

.iframe_contentp,
.giframe_contentp {
    width: 74%;
    float: right;
}

/*gravity iframe*/
iframe#secCodeIframe {
    width: 100px;
}

#tip-info {
    margin-left: 2px;
    margin-right: -6px;
}

@media only screen and (max-width: 300) {
    .iframe_label label#scode {
        display: unset;
    }
}

label[for="save_card"] {
    font-weight: bold !important;
}
</style>
